import { WheelSnapshot } from '../../state/WheelSnapshot';
import { LifePart } from '../../state/LifePart';

export interface WheelBalanceData {
    uuid: string;
    name: string;
    color: string;
    startpoint: number;
    primary: boolean;
}

export interface LifePartPeriodData {
    uuid: string;
    name: string;
    color: string;
    initialName: string | null;
    finalName: string | null;
    initialScore: number | null;
    finalScore: number | null;
    hasInitialData: boolean; // есть ли данные на начало периода
    totalSteps: number; // общее количество шагов (всегда 10)
    averageEfficiency?: number | null; // средняя эффективность за период (0-8)
    efficiencySnapshotsCount?: number; // количество снимков эффективности
}

/**
 * Извлекает данные LifePart из начального и конечного снимков
 * @param initialSnapshot - снимок колеса на начальную дату (максимальная дата <= dateFrom)
 * @param finalSnapshot - снимок колеса на конечную дату (максимальная дата <= dateTo)
 * @param lifePartUuids - UUID выбранных сфер жизни
 * @param averageEfficiencies - карта UUID -> средняя эффективность (опционально)
 * @param efficiencySnapshotsCounts - карта UUID -> количество снимков эффективности (опционально)
 */
export function extractLifePartPeriodData(
    initialSnapshot: WheelSnapshot | null,
    finalSnapshot: WheelSnapshot | null,
    lifePartUuids: string[],
    averageEfficiencies?: Map<string, number | null>,
    efficiencySnapshotsCounts?: Map<string, number>,
): LifePartPeriodData[] {
    if (lifePartUuids.length === 0) return [];
    const TOTAL_STEPS = 10;

    return lifePartUuids.map(uuid => {
        const initialParts = initialSnapshot?.lifeParts || [];
        const finalParts = finalSnapshot?.lifeParts || [];

        const initialPart = initialParts.find(p => p.uuid === uuid);
        const finalPart = finalParts.find(p => p.uuid === uuid);

        // Сфера существует на конец периода только если есть в финальном снимке
        const hasFinalData = finalPart !== undefined;
        const hasInitialData = initialPart !== undefined;

        return {
            uuid,
            name: finalPart?.name || initialPart?.name || 'Без названия',
            color: finalPart?.color || initialPart?.color || '#6c757d',
            initialName: hasInitialData ? (initialPart?.name || 'Без названия') : null,
            finalName: hasFinalData ? (finalPart?.name || 'Без названия') : null,
            initialScore: hasInitialData ? (initialPart?.startpoint || 0) : null,
            finalScore: hasFinalData ? (finalPart?.startpoint || 0) : null,
            hasInitialData,
            totalSteps: TOTAL_STEPS,
            averageEfficiency: averageEfficiencies?.get(uuid) ?? null,
            efficiencySnapshotsCount: efficiencySnapshotsCounts?.get(uuid) ?? 0,
        };
    });
}
